import axios from 'axios';

// Use relative URL - API calls will go through the same domain
// On Netlify: /api/* -> /.netlify/functions/api/*
// On Emergent: /api/* -> backend:8001/api/*
const API = '/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Quran API functions
export const quranApi = {
  // Get list of all surahs
  getSurahs: async () => {
    const response = await api.get('/quran/surahs');
    return response.data;
  },

  // Get list of reciters
  getReciters: async () => {
    const response = await api.get('/quran/reciters');
    return response.data;
  },

  // Get complete surah
  getSurah: async (surahNo) => {
    const response = await api.get(`/quran/surah/${surahNo}`);
    return response.data;
  },

  // Get specific verse
  getVerse: async (surahNo, ayahNo) => {
    const response = await api.get(`/quran/verse/${surahNo}/${ayahNo}`);
    return response.data;
  },

  // Get tafsir of a verse
  getVerseTafsir: async (surahNo, ayahNo) => {
    const response = await api.get(`/quran/tafsir/${surahNo}/${ayahNo}`);
    return response.data;
  },

  // Get tafsir of entire surah
  getSurahTafsir: async (surahNo) => {
    const response = await api.get(`/quran/tafsir/${surahNo}`);
    return response.data;
  },

  // Get audio for a verse
  getVerseAudio: async (surahNo, ayahNo) => {
    const response = await api.get(`/quran/audio/${surahNo}/${ayahNo}`);
    return response.data;
  },

  // Get audio for entire surah
  getSurahAudio: async (surahNo) => {
    const response = await api.get(`/quran/audio/${surahNo}`);
    return response.data;
  },

  // Get full translation
  getFullTranslation: async (language) => {
    const response = await api.get(`/quran/translation/${language}`);
    return response.data;
  },
};

export default api;
